import './About.css';
import aboutBackgroundImage from '../../images/aboutMe_Img.png';

const icons = {
  location: '◎',
  experience: '↗',
  specialization: '✦',
};

function About({ content }) {
  return (
    <section
      className="section about"
      id="about"
      style={{ '--about-background-image': `url(${aboutBackgroundImage})` }}
    >
      <div className="section__content about__layout">
        <header>
          <p className="eyebrow">{content.eyebrow}</p>
          <h2 className="section-title">{content.title}</h2>
        </header>
        <div>
          {content.paragraphs.map((paragraph) => <p className="about__copy" key={paragraph}>{paragraph}</p>)}
          <ul className="about__highlights">
            {content.highlights.map((item) => (
              <li key={item.label}>
                <span className="about__icon" aria-hidden="true">{icons[item.icon]}</span>
                {item.label}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}

export default About;
